<template>
    <div>
        <Card>
            <div class="search-con search-con-top">
                <Form :model="form" :label-width="80" inline>
                    <FormItem label="邮箱帐号">
                        <Input v-model="form.account"></Input>
                    </FormItem>
                    <FormItem label="状态">
                      <Select v-model="form.status">
                        <Option value="">-全部-</Option>
                        <Option :value="item.key" v-for="(item, index) in statusOptions" :key="index">{{item.name}}</Option>
                      </Select>
                    </FormItem>
                </Form>
                <div  class="toolbar">
                    <Button type="primary" icon="md-add" @click="handleCreate">新增</Button>
                    <!-- <Button type="primary" icon="md-trash" @click="handleDelete">删除</Button> -->
                   <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索 </Button>
                </div>
            </div>
            <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
                    @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
        </Card>
        <mailwhiteInfo ref="mailwhiteInfoRef"  @handle-search="handleSearch"></mailwhiteInfo>
    </div>
</template>

<script>
import mailwhiteInfo from './mailwhite-info'
import { getIds } from '@/libs/util'

export default {
  name: 'mailwhite-list',
  components: {
    mailwhiteInfo
  },
  data () {
    return {
      columns: [
        // { title: '', key: 'id', type: 'selection', width: 60 },
        { title: '邮箱帐号', key: 'account' },
        { title: '邮箱名称', key: 'bankName' },
        // { title: '邮箱密码', key: 'password' },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('span', this.getStatusVal(params.row.status))
          }
        },
        { title: '创建时间', key: 'crtTime' },
        { title: '修改人', key: 'mdfUserId' },
        { title: '修改时间', key: 'mdfTime' },
        {
          title: '操作',
          key: 'handle',
          minWidth: 200,
          options: ['update', 'detail']
        }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        map: {}
      },
      statusOptions: [
        { key: 0, name: '禁用' },
        { key: 1, name: '启用' }
      ],
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleUpdate (param) {
      this.$refs.mailwhiteInfoRef.openModel('update', param.row)
    },
    handleDetail (param) {
      this.$refs.mailwhiteInfoRef.openModel('detail', param.row)
    },
    handleCreate () {
      this.$refs.mailwhiteInfoRef.openModel('create')
    },
    handleDelete () {
      this.D('mailwhite', getIds(this.selectedData)).then(data => {
        this.$Message.success(data)
        this.handleSearch()
      })
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    getStatusVal (status) {
      return status === 0 ? '禁用' : '启用'
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      var param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: this.form.map
      }
      this.L('mailwhite', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
